<template>
  <div class="container">
    <h3 v-if="playground.id">{{ sessionType }}: {{ playground.name || playground.id }}</h3>
    <playground-card />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import PlaygroundCard from './PlaygroundCard';
import { generationSessionType } from '@/utils/generationSessions';

export default {
  components: {
    PlaygroundCard,
  },
  created() {
    this.fetchData();
  },
  computed: {
    ...mapGetters(['playground']),
    sessionType() {
      return generationSessionType(this.playground);
    },
  },
  methods: {
    ...mapActions(['getPlayground']),
    async fetchData() {
      const { query: id } = this.$route.params;
      try {
        this.getPlayground(id);
      } catch (e) {
        this.$notify.error({
          title: "Couldn't fetch playground info :(",
        });
      }
    },
  },
  watch: {
    '$route.params'() {
      this.fetchData();
    },
  },
};
</script>

<style scoped>
.container > * + * {
  margin-top: 10px;
}
</style>
